import Cookie from 'js-cookie'
import { isAndroid, isIOS } from 'react-device-detect'
import gtmEvent from '../../../utils/gtm'

export const getDeviceType = () => {
  if (isAndroid) return 'android'
  if (isIOS) return 'ios'
  return 'unknown'
}

export const setBannerCookie = () => {
  Cookie.set('appInstalledOrDismissed', 'nodisplay', {
    expires: 15,
    secure: true,
    sameSite: 'Lax',
    path: '/'
  })
}

export const handleCtaClick = (setIsDisplaying, app) => () => {
  const device = getDeviceType()
  setBannerCookie()
  setIsDisplaying(false)
  gtmEvent({
    event: 'app-banner-click',
    appBannerCategory: 'app-banner',
    appBannerLabel: 'upload-app',
    appBannerAction: 'click-install',
    metaData: {
      device,
      app
    }
  })
}

export const handleDismiss = (setIsDisplaying, app) => () => {
  const device = getDeviceType()
  setBannerCookie()
  setIsDisplaying(false)
  gtmEvent({
    event: 'app-banner-click',
    appBannerCategory: 'app-banner',
    appBannerLabel: 'close-banner',
    appBannerAction: 'click-close',
    metaData: {
      device,
      app
    }
  })
}
